export class BaseApiResponseModel<T extends Object> {
  passedDelete: any;
  constructor(
    public code?: number,
    public data?: T,
    public message?: string,
    public pagination?: Paging
  ) {}
}

export class SingleBaseResponseModel<T extends Object> {
  data: {
    data?: T;
    error?: Error;
    message?: string;
    code?: number;
  };
}

export interface Paging {
  limit?: number;
  page?: number;
  total?: number;
  success?: number;
  error?: number;
  other?: number;
  revenue?: number;
}

export class Error {
  code?: number;
  message?: string;
}

export class Report {
  day?: number;
  week?: number;
  month?: number;
  lastMonth?: number;
}

export class Result {
  type: "success" | "error";
  message: string;
}

export class SelectList {
  label?: string;
  value?: any;
  color?: string;
  code?: string;
  userStoreId?: string;
}

export default {
  BaseApiResponseModel,
  Error,
};
